export const httpStatus = {
    setStatusCode: 'httpStatus/setStatusCode',
    setIsShow: 'httpStatus/setIsShow',
    setStatusData: 'httpStatus/setStatusData',
};

export const alertData = {
    setMsg: 'alertData/setMsg',
    setIsShow: 'alertData/setIsShow',
    setCallback: 'alertData/setCallback',
    setIsShowCancelBtn: 'alertData/setIsShowCancelBtn',
};

export const pageData = {
    setIsLoading: 'pageData/setIsLoading',
    setIsFirstEdit: 'pageData/setIsFirstEdit',
};
